import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { PersonPortalState } from '@app/models/person-portal-state';
import { LocalStorageUtilities } from '@app/utilities/local-storage-utilities';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    let personPortalState: PersonPortalState = LocalStorageUtilities.getPersonPortalState();
    if (personPortalState && personPortalState.token) {            
        request = request.clone({          
            setHeaders: {                            
                Authorization: `Bearer ${personPortalState.token}`
            }
        });
    }
    return next.handle(request);
  }
}
